// Persists per-rule-set regime + asset register selections in localStorage.
// These selections are UI-only context for condition-value pickers; they are
// not stored on the rule set itself on the server.

const STORAGE_KEY = "optimiser.ruleSetContext"

export function loadRuleSetContext(ruleSetId) {
    if (!ruleSetId) return { regime: null, assetRegister: null }
    try {
        const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}")
        return all[ruleSetId] || { regime: null, assetRegister: null }
    } catch {
        return { regime: null, assetRegister: null }
    }
}

export function saveRuleSetContext(ruleSetId, context) {
    if (!ruleSetId) return
    try {
        const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}")
        all[ruleSetId] = {
            regime: context?.regime || null,
            assetRegister: context?.assetRegister || null,
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
    } catch {
        // ignore quota/serialization errors
    }
}
